import { useCallback, useState } from "react";
import { API_URL } from "../config";
import { useAuth } from "../providers";

export const useMutation = ({
  url,
  method = "POST",
  onSuccess,
  onError,
  options = {},
}) => {
  const { token } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const executeMutation = useCallback(
    async (body) => {
      setLoading(true);
      setError(null);
      try {
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          ...options.headers,
        };

        const response = await fetch(`${API_URL}${url}`, {
          method,
          headers: token === null ? options.headers : headers,
          body: body ? JSON.stringify(body) : undefined, // Solo enviar body si existe
          ...options,
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        //if respose have no content return null
        const result = response.status === 204 ? null : await response.json();
        setData(result);
        onSuccess?.(result); // Llamar a onSuccess si existe
      } catch (err) {
        setError(err);
        onError?.(err); // Llamar a onError si existe
      } finally {
        setLoading(false);
      }
    },
    [url, method, options, token, onSuccess, onError]
  );

  return { data, error, loading, executeMutation };
};
